var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ta-total-items-found"},[_vm._v(" "+_vm._s(_vm.lots.totalRows == 1 ? _vm.$t('{total} item found', {total: _vm.lots.totalRows}) : _vm.$t('{total} items found', {total: _vm.lots.totalRows}))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }